module.exports = {"name":"ooyala","type":"adapter","tech":"js","author":"Jesus Lopez","version":"6.1.0","built":"2018-02-27","repo":"https://bitbucket.org/npaw/ooyala-adapter-js","libVersion":"6.1.12","features":{"buffer":"monitor","seek":"native","getters":["getPlayhead","getDuration","getBitrate","getRendition","getTitle","getIsLive","getResource"]},"ads":[{"buffer":"monitor","seek":"monitor","getters":["getPlayhead","getDuration","getBitrate","getRendition","getTitle","getResource","getPosition"],"filename":"adsadapter.js"}]}


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 15
// module chunks = 0